"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cards = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var ra_fetch_1 = require("ra-fetch");
var Cards = function (_a) {
    var user = _a.user, channel = _a.channel;
    var _b = ra_fetch_1.useApi('ecommerce').index('plans', { channel_id: channel.id }), plans = _b[0], setPlans = _b[1];
    var destroy = function (plan) {
        ra_fetch_1.Fetcher.api('ecommerce')
            .records(plans.data)
            .delete('plans', { id: plan.id })
            .then(function (response) {
            if (response.errors.length) {
                return;
            }
            setPlans(response.records);
        });
    };
    if (plans.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!plans.data.length) {
        return react_1.default.createElement(storybook_1.Forms.New, { description: 'Je hebt nog geen abonnementen', label: 'Nieuw abonnement', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/subscriptions/create", icon: 'plus' });
    }
    return react_1.default.createElement(storybook_1.Grids.List, null, plans.data.map((function (plan, index) {
        return react_1.default.createElement(storybook_1.Cards.Card, { key: index },
            react_1.default.createElement("div", { className: 'storybook-plans-card-image', style: plan.thumbnail ? { backgroundImage: "url(" + plan.thumbnail + ")" } : {} }),
            react_1.default.createElement(storybook_1.Cards.Content, null,
                react_1.default.createElement("div", { className: 'storybook-plans-card-heading' },
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h4' }, plan.label),
                    react_1.default.createElement("div", { className: 'storybook-plans-card-icons' },
                        user.permissions.includes('ecommerce.plans.update') &&
                            react_1.default.createElement("a", { href: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/subscriptions/" + plan.id + "/edit" },
                                react_1.default.createElement(storybook_1.Icons.Icon, { name: 'pencil', className: 'storybook-icons-icon' })),
                        user.permissions.includes('ecommerce.plans.destroy') &&
                            react_1.default.createElement("span", { onClick: function () { return destroy(plan); } },
                                react_1.default.createElement(storybook_1.Icons.Icon, { name: 'trash', className: 'storybook-icons-icon cursor-pointer' })))),
                react_1.default.createElement(storybook_1.Texts.Secondary, null,
                    plan.subs,
                    " abonnees")),
            react_1.default.createElement(storybook_1.Cards.Buttons, null,
                react_1.default.createElement(storybook_1.Cards.Button, { className: 'storybook-plans-cards-button-month' },
                    "\u20AC",
                    plan.month,
                    " / MAAND"),
                react_1.default.createElement(storybook_1.Cards.Button, { className: 'storybook-plans-cards-button-year' },
                    "\u20AC",
                    plan.year,
                    " / JAAR")));
    })));
};
exports.Cards = Cards;
exports.Cards.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
        name: prop_types_1.default.string.isRequired,
    }).isRequired,
};
